import { useState } from "react"

const useStoreDetail = () => {
  
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  }

  const close = () => {
    setIsOpen(false);
  }

  return {
    open,
    onCancel: close,
    isOpen
  }

}

export default useStoreDetail;